<script lang="ts">
    import { CustomIcon, getIcon } from '@components/icons';
    import { LL } from '@i18n/i18n-svelte';
    import { Input, InputTypes } from '@uikit/form/input';

    export let value = '';
    export let isSignUp = false;
    export let classes = '';
    export let validationError: string | undefined;
    export let disabled = false;
</script>

<Input
    bind:value
    {classes}
    type={InputTypes.Type.text}
    inline
    placeholder={`${$LL.auth.email()}*`}
    name="email"
    iconLeft={getIcon(CustomIcon.message)}
    counter={false}
    attrs={ { autocomplete: isSignUp ? 'off' : 'email' } }
    required
    state={validationError ? InputTypes.State.error : undefined}
    disabled={disabled}
/>
